// extracted by mini-css-extract-plugin
module.exports = {"tag":"styles_tag__3e50v","tagLink":"styles_tagLink__1474h"};